export const SIEM_DASHBOARD = {
  TITLE: 'SIEM',
  SUBTITLE: 'Security information and event management',
  TABS: {
    OVERVIEW: 'Overview',
    LOG_EXPLORER: 'Log Explorer',
    ALERTS: 'Alerts',
  },
  CUSTOM_RANGE: {
    TITLE: 'Custom range',
    FROM: 'From',
    TO: 'To',
    APPLY: 'Apply',
  },
  EVENTS: 'events',
  AGENT: 'agent',
  AGENTS: 'agents',
  MORE: 'more',
  RAW_DASHBOARDS: {
    LABEL: 'Raw Dashboards',
    SECURITY: 'Raw Security',
    STATISTICS: 'Raw Statistics',
    AGENTS: 'Raw Agents',
    DOWNLOAD_AGENT: 'Download agent',
  },
  PRIORITIES: {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    CRITICAL: 'Critical',
  },
  CONNECTIONS: {
    TITLE: 'Connections',
    DESCRIPTION: 'Outside business hours',
    EMPTY: 'No connections outside business hours',
    COLUMNS: {
      TIMESTAMP: 'Timestamp',
      AGENT: 'Agent',
      USER: 'User',
      SOURCE: 'Source',
      LOCATION: 'Location',
      DIRECTION: 'Direction',
    },
  },
  TIMELINE: {
    TITLE: 'Timeline',
    EVENTS: 'Events',
    ALERTS: 'Alerts',
    TOTAL: 'Total',
  },
  AUTH_EVENTS: {
    TITLE: 'Authentication',
    FAILED_LOGINS: 'Failed logins',
    BRUTE_FORCE: 'Brute force',
    USER_LOCKOUTS: 'User lockouts',
    SUCCESSFUL_LOGINS: 'Successful logins',
    NO_HOST_ACTIVITY: 'No host activity',
  },
  ALERTS: {
    TITLE: 'Latest Alerts',
    EMPTY: 'No alerts in range',
    TOOLTIP: 'Displaying last 10 alerts triggered by High (12-14) or Critical (15) events',
    VIEW_ALL: 'View all',
  },
  LOG_EXPLORER: {
    SEARCH_PLACEHOLDER: 'Search rule or agent',
    EMPTY: 'No logs in range',
    COLUMNS: {
      TIMESTAMP: 'Timestamp',
      SEVERITY: 'Severity',
      AGENT: 'Agent',
      DESCRIPTION: 'Description',
      OCCURRENCES: 'Count',
    },
    FILTERS: {
      FILTER_BY_SEVERITY: 'Filter by severity',
      FILTER_BY_AGENT: 'Filter by agent',
    },
    DRAWER: {
      LATEST_HIT: 'Latest event',
      OCCURRENCES: 'Occurrences',
      HITS: 'Latest events',
      HIT: 'Event',
      RAW_LOG: 'Raw log',
      EMPTY: 'No events found for this rule.',
      ERROR: 'Failed to load events.',
      DOWNLOAD: 'Export',
      DOWNLOAD_JSON: 'Export as JSON',
      DOWNLOAD_CSV: 'Export as CSV',
      CASE: {
        CREATE: 'Create case',
        TITLE: 'Create case',
        FIELD_DESCRIPTION: 'Description',
        FIELD_MITRE: 'MITRE tactic',
        MITRE_NONE: 'None',
        SUBMIT: 'Create',
        CANCEL: 'Cancel',
        SUCCESS: 'Case created successfully',
        ERROR: 'Failed to create case',
      },
      STATUS: {
        TITLE: 'Status',
        OPEN: 'Open',
        CLOSED: 'Closed',
        CLOSED_BADGE: 'Closed',
      },
      CLOSURE: {
        SECTION: 'Closure',
        CLOSE: 'Close alert',
        REOPEN: 'Reopen alert',
        TITLE: 'Close alert',
        REASON_LABEL: 'Reason for closure',
        NOTES_LABEL: 'Additional notes',
        AFFECTED_DATA_LABEL: 'Is there affected data?',
        AFFECTED_DATA_YES: 'Yes',
        AFFECTED_DATA_NO: 'No',
        CONFIRM: 'Close alert',
        CANCEL: 'Cancel',
        CLOSE_SUCCESS: 'Alert closed successfully',
        REOPEN_SUCCESS: 'Alert reopened successfully',
        ERROR: 'Failed to update alert',
      },
    },
  },
}

export const EDR_SIEM = {
  TITLE: 'EDR & SIEM',
  DASHBOARD: {
    TITLE: 'Dashboard',
    DESCRIPTION:
      'Centralized view of monitoring data, showcasing alerts, ' +
      'threat trends and real-time activity across all-deployed agents.',
    URLS: {
      SECURITY: 'Security Events Dashboard',
      STATISTICS: 'Event Statistics Dashboard',
      AGENTS: 'Agents Dashboard',
    },
  },
  AGENT: {
    TITLE: 'Agent',
    DESCRIPTION:
      'Quick access to download and deploy agents on your devices, ' +
      'ensuring comprehensive coverage for monitoring.',
    DOWNLOAD: {
      LINUX: 'Download Qalea Monitoring Agent',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentation',
    DESCRIPTION:
      'Guidelines for setting up and managing agent deployment, ' +
      'as well as understanding detailed monitoring coverage.',
    URLS: {
      DEVICE: 'Installing the agent in your device',
      AWS: 'Installing the agent in AWS instances',
      EKS: 'Installing the agent in an EKS cluster',
      MONITORING: 'Monitoring coverage detail',
    },
  },
  RELEVANT_TRENDS: {
    TITLE: 'Relevant Events',
    DESCRIPTION:
      'Explore here the most relevant events and patterns in recent alerts to identify recurring threats, ' +
      'monitor emerging risks, and gain insights into your security posture. ' +
      'This overview assists in prioritizing areas that require immediate attention ' +
      'and guides proactive actions to strengthen defenses.',
    TRENDS_NOT_YET_AVAILABLE:
      'Event Analysis will be available once sufficient alert data has been collected. ' +
      'Please check back later to review critical insights and significant patterns as they develop over time',
  },
}
